export default __webpack_public_path__ + "static/dvmf-logo-fd5c55254399a248ff1f9a59fde02446.svg";